import { render, staticRenderFns } from "./TicketsReport.vue?vue&type=template&id=7b07e1f0&scoped=true&"
import script from "./TicketsReport.vue?vue&type=script&lang=js&"
export * from "./TicketsReport.vue?vue&type=script&lang=js&"
import style0 from "./TicketsReport.vue?vue&type=style&index=0&id=7b07e1f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b07e1f0",
  null
  
)

export default component.exports